module.exports = __webpack_public_path__ + "static/media/UC-d8477c13-2403-4831-af0c-b82b430a348b.6ab91f05.jpg";